<template>
    <b-card :header-class="'alert-' + variant" :bg-variant="variant" text-variant="light" class="text-center">
        <div slot="header">
            <h6 style="white-space:nowrap;">{{ title }}</h6>
        </div>
        <b-card-text>
            <h6>{{ Math.abs(coeff).toFixed(0) }} %</h6>
            <h6>{{ msg }}</h6>
        </b-card-text>
    </b-card>
</template>

<script>
    import _ from "lodash";
    import Diagnosis from "../Diagnosis";

    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
            coeff: {
                type: Number,
                default: 0,
            }
        },
        computed: {
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: Diagnosis.data().muscleLevel
            }
        },
        methods: {
            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeff);
                });
            }
        }
    }
</script>